import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import MiljokontrollOversiktFilter from "./MiljokontrollOversiktFilter";

import {
    handleChangeAll as handleChangeAllAction,
    handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";
import { getMiljokontroller as getMiljokontrollerAction } from "../../../actions/miljokontrollerActions";
import { getOvertredelseskoderMiljogebyr as getOvertredelseskoderMiljogebyrAction } from "../../../actions/overtredelseskoderMiljogebyrActions";

import { getOvertredelseskoder } from "../../../selectors/miljogebyrTilBehandlingSelector";

import * as inputValidation from "../../../utils/inputValidationUtils";
import { replaceWhitespacesWithEmptyStrings } from "../../../utils/sanitizationUtils";

const handleBlur = (e, filterState, setFilterState) => {
  const name = e.target.name;
  const value = replaceWhitespacesWithEmptyStrings(e.target.value);
  setFilterState({ ...filterState, [name]: value });
};

const isValid = (filterState, validationErrorState, setValidationErrorState) => {
  const dateTimeValidationError =
    inputValidation.getDateTimeValidationError(filterState);
  setValidationErrorState({ ...validationErrorState, ...dateTimeValidationError });
  return Object.values(dateTimeValidationError).every((value) => !value);
};

const handleSubmit = (
  e,
  filterState,
  validationErrorState,
  setValidationErrorState,
  setShowSpinnerState,
  handleChangeAll,
  getMiljokontroller
) => {
  e.preventDefault();
  if (isValid(filterState, validationErrorState, setValidationErrorState)) {
    setShowSpinnerState(true);
    getMiljokontroller({ ...filterState })
      .then(() => {
        handleChangeAll({ ...filterState });
        setShowSpinnerState(false);
      })
      .catch(() => setShowSpinnerState(false));
  }
};

const getOvertredelseskodeParagraf = (id, overtredelseskoder) => {
  if (overtredelseskoder) {
    const match = overtredelseskoder.find((o) => o.id === id);
    if (match) return match.paragraf;
  }
  return null;
};

export default function MiljokontrollOversiktFilterContainer() {
  const dispatch = useDispatch();
  const miljokontrollOversiktFilterForm = useSelector(
    (state) => state.forms.miljokontrollOversiktFilterForm
  );
  const overtredelseskoder = useSelector(getOvertredelseskoder);

  const handleChangeAll = (payload) =>
    dispatch(
      handleChangeAllAction("MILJOKONTROLL_OVERSIKT_FILTER_FORM", payload)
    );
  const getMiljokontroller = (params) =>
    dispatch(getMiljokontrollerAction(params));

  const getOvertredelseskoderMiljogebyr = useCallback(
    () => dispatch(getOvertredelseskoderMiljogebyrAction()),
    [dispatch]
  );
  const getOvertredelseskodeParagrafHandler = useCallback(
    (id) => getOvertredelseskodeParagraf(id, overtredelseskoder),
    [overtredelseskoder]
  );

  return (
    <MiljokontrollOversiktFilter
      miljokontrollOversiktFilterForm={miljokontrollOversiktFilterForm}
      overtredelseskoder={overtredelseskoder}
      getOvertredelseskodeParagraf={getOvertredelseskodeParagrafHandler}
      handleBlur={(e, filterState, setFilterState) =>
        handleBlur(e, filterState, setFilterState)
      }
      handleSubmit={(
        e,
        filterState,
        validationErrorState,
        setValidationErrorState,
        setShowSpinnerState
      ) =>
        handleSubmit(
          e,
          filterState,
          validationErrorState,
          setValidationErrorState,
          setShowSpinnerState,
          handleChangeAll,
          getMiljokontroller
        )
      }
      handleChangeToInitState={() =>
        dispatch(
          handleChangeToInitStateAction("MILJOKONTROLL_OVERSIKT_FILTER_FORM")
        )
      }
      getOvertredelseskoderMiljogebyr={getOvertredelseskoderMiljogebyr}
    />
  );
}
